export default class NutritionTextSection {

  constructor(options) {

    this.elem = $(options.elem);
    this.name = options.name;

    // parallax copy modifier
    this.elemIsOnScreen = false;
    this.tY = 0;
    this.tO = 0;

    // $(window).scroll( (e) => this.handleScroll );
    // $(window).resize( () => this.handleResize );

    console.log('N TEXT SECTION CONTROLLER');
  }

  setupParallaxCopy() {

    const vpt = 0;
    const vpb = $(window).height();
    const st = $(window).scrollTop();
    const travelY = -100;

    if ( this.elem.offset().top - st < vpb && ( this.elem.height() + this.elem.offset().top ) - st > vpt ) {
      const vpc = -( this.elem.offset().top - st - vpb );
      const vpmax = this.elem.height() + vpb;
      const vpp = ( vpc / vpmax );

      this.tY = ( travelY * vpp ) - ( travelY / 2 );
      this.tO = 1;

      if ( vpp < 0.49 ) {
        this.tO = (vpp / 0.49) * 1;
      } else if ( vpp > 0.51 ) {
        this.tO = ( ( 1 - vpp ) / 0.49) * 1;
      }

      if ( this.tO > 1 ) {
        this.tO = 1;
      }

      this.elemIsOnScreen = true;
      this.updateUI();

      // console.log(this.name,' IS ON SCREEN');
    } else {
      this.elemIsOnScreen = false;
      // console.log(this.name,' IS OFF SCREEN');
    }


  }

  // setup the UI render loop for all elements within the component
  updateUI() {
    if ( this.elemIsOnScreen ) {
      this.elem.find('div.n_section_cntr').css('transform', `translate(0,${-this.tY * 4}% )`);
      this.elem.find('div.n_section_cntr').css('opacity', this.tO);
    }
  }


  handleResize() {

  }

  handleScroll() {
    // this.setupParallaxCopy();
  }

}



// WEBPACK FOOTER //
// ./js/controllers/components/NutritionTextSection.js